import { render, staticRenderFns } from "./CabinViewPopup.vue?vue&type=template&id=1c0d3842&scoped=true&"
import script from "./CabinViewPopup.vue?vue&type=script&lang=js&"
export * from "./CabinViewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d3842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0d3842')) {
      api.createRecord('1c0d3842', component.options)
    } else {
      api.reload('1c0d3842', component.options)
    }
    module.hot.accept("./CabinViewPopup.vue?vue&type=template&id=1c0d3842&scoped=true&", function () {
      api.rerender('1c0d3842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/CabinViewPopup.vue"
export default component.exports